const openPopupButtons = document.querySelectorAll("[data-open-popup]");
if (openPopupButtons) {
  function openPopup() {
    document.getElementById("popupForm").style.display = "block";
  }

  openPopupButtons.forEach((button) => {
    button.addEventListener("click", openPopup);
  });

  document.querySelector("[data-close-popup]")?.addEventListener("click", function () {
    document.getElementById("popupForm").style.display = "none";
  });

  document.getElementById("popupOverlay")?.addEventListener("click", function () {
    document.getElementById("popupForm").style.display = "none";
  });
}
